import styled from '@emotion/styled';

export const DivDialogBody = styled.div`
  display: block;
  font-size: 13px;
  white-space: pre-line;
  padding-top: 1rem;
`;

export const DivHeadline = styled.div`
  display: block;
  font-size: 17px;
  white-space: pre-line;
  font-weight: bold;
`;

export const DivTitle = styled.div`
  display: block;
  font-size: 15px;
  white-space: pre-line;
`;

